// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb-item":"_3lyK8OooH9BWh1wHXAdwTL","breadcrumb-last-item":"_2rO8V_yo7fat1Rv3nlfC3Z","separator":"_1Z2WQR0IcvSWaAgxtmgljU","breadcrumb":"_17ZA2aQYdxXc7mteT2QDuM _13UyNN6lRQaIE4nGDzE2-d","breadcrumb-hidden":"_1W4CorlN8AMJGoX4oKVBqr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs/Breadcrumbs.scss
// module id = 62
// module chunks = 0 2 7 9 12 13 14 17 20 38 41